var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"15px 0"},domProps:{"innerHTML":_vm._s(_vm.layout.description.replace(/\n/g,"<br>"))}})}
var staticRenderFns = []

export { render, staticRenderFns }